module.exports = __webpack_public_path__ + "media/faucet.c066f696.mp4";